import { createApiAction } from 'redux/redux-actions';
import restApis from '../restApis';
import { CREATE_SOCIAL_CONTACTS, LIST_SOCIAL_CONTACTS } from '../constants';

const socialContactsApi = restApis('social-contacts');

export const bulkCreateSocialContacts = createApiAction(
  CREATE_SOCIAL_CONTACTS,
  socialContactsApi.create,
);
export const listSocialContacts = createApiAction(LIST_SOCIAL_CONTACTS, socialContactsApi.list);
